module.exports = __webpack_public_path__ + "static/media/readrr.8aececca.jpeg";